module.exports = __webpack_public_path__ + "img/trophy-gold.781ec7cf.svg";